module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_4.abc64577.png";